module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_9016.ea5c6532.png";